import { Component, NgZone, OnInit, ViewChild } from '@angular/core';

import { transition } from '@angular/core/src/animation/dsl';
// import { CalendarComponentOptions } from 'ion2-calendar';
import { NavController, MenuController, LoadingController, ModalController, AlertController, Content, Events, Platform, ActionSheetController } from 'ionic-angular';
import { ServerService } from '../../services/server-service';
import { ToastService } from '../../services/toast-service';
import moment from 'moment';
import swal from 'sweetalert';

import { LocalNotifications } from '@ionic-native/local-notifications';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {
  isQuestionnaireSubmitted,
  openQuestionnaireModal,
} from '../../components/app-questionnaire/open-questionnaire-modal';
import { GoogleChartInterface } from 'ng2-google-charts/google-charts-interfaces';
import { ChartSelectEvent } from 'ng2-google-charts';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnInit {
  matnasName: any = '';
  matnasImage: any = '';
  newsItems: any = [];
  showNews: boolean = false;
  showFutureEvents: boolean = false;
  newsLoading: boolean = true;
  futureEventsLoading: boolean = false;
  // barCode: any = '';
  // lastDigitsPersonalId: any = '';
  personalFound: boolean = true;
  personalFullName: any = '';
  healthDeclareShow: boolean = false;
  showScrollTop: boolean = false;
  futureEvents: any = [];
  @ViewChild('pageTop') content: Content;
  // showRooEvents: any = '';
  mercazHugimVsActivity: any = 1;
  mustDeclareHealthGeneral: boolean = false;
  showScroller: boolean = false;

  activeTechNotifications: any = [];
  showActiveTecNotifications: boolean = false;

  welcomeText: string = '';

  isAndroid: boolean = false;

  /** Show the standalone “rate on store” CTA only on real iOS / Android builds */
  showRateStore: boolean = false;
  storeRateLabel: string = 'App Store';

  showQuestionnaire: boolean = true;

  // ===== Rate-app modal test flag =====
  // TRUE  -> modal opens every time you visit Home (ignores platform + localStorage gate)
  // FALSE -> production behaviour (cordova iOS/Android, once-per-device via localStorage)
  // Remember to set this back to false before release.
  private readonly RATE_MODAL_TEST_MODE: boolean = false;


  showQR: boolean = false;
  private textTimer: any;
  private hideTimer: any;


  qrImage: string = '';

  showWeeklyRegChart: boolean = false;
  weeklyRegChart: GoogleChartInterface;
  weeklyRegChartLoading: boolean = false;
  weeklyChartDays: Array<{ iso: string; label: string; count: number; hugNames: string[] }> = [];
  selectedChartDay: { label: string; count: number; hugNames: string[] } | null = null;
  weeklyRegWeekTotal: number = 0;

  private readonly hebrewWeekDays: string[] = [
    'ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת',
  ];

  private readonly weeklyRegBarColors: string[] = [
    '#6366f1', '#3b82f6', '#0ea5e9', '#06b6d4', '#8b5cf6', '#14b8a6', '#f59e0b', '#ec4899',
  ];

  menuActions: Array<{ title: string, subtitle: string, component: any, icon: string, color: string }> = [
    { title: 'רישום לפעילויות', subtitle: 'הרשמה לחוגים ופעילויות', component: 'registerActivity', icon: 'checkmark-circle', color: 'primary' },
    { title: 'הצג קוד', subtitle: 'הקוד האישי שלי', component: 'showQr', icon: 'qr-scanner', color: 'accent' },
    { title: 'הקבלות שלי', subtitle: 'מסמכים שהונפקו', component: 'ReciptsPage', icon: 'copy', color: 'info' },
    { title: 'ההזמנות שלי', subtitle: 'היסטוריית הזמנות', component: 'MyordersmainPage', icon: 'document', color: 'secondary' },
    { title: 'פעילויות לתשלום', subtitle: 'תשלומים פתוחים', component: 'FuturepayPage', icon: 'pricetag', color: 'warning' },
    { title: 'אירועים', subtitle: 'אירועים פעילים', component: 'EventsPage', icon: 'calendar', color: 'teal' },
    { title: 'חוגים', subtitle: 'רשימת חוגים', component: 'HugimlistPage', icon: 'people', color: 'success' },
    { title: 'פנה אלינו', subtitle: 'תמיכה ויצירת קשר', component: 'ContactusPage', icon: 'mail', color: 'secondary' },
    { title: 'שיתוף', subtitle: 'שיתוף האפליקציה', component: 'shareApp', icon: 'share', color: 'warning' },
  ];

  constructor(public navCtrl: NavController,
    public menuCtrl: MenuController,
    private api: ServerService,
    private toast: ToastService,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    private alertCtrl: AlertController,
    public events: Events,
    public zone: NgZone,
    public platform: Platform,
    private localNotifications: LocalNotifications,
    private iab: InAppBrowser,
    public actionSheetCtrl: ActionSheetController,
  ) {
    this.matnasName = localStorage.getItem('mercazName');
    this.matnasImage = localStorage.getItem('mercazImage');
    this.personalFullName = localStorage.getItem('userName');

    // this.menuCtrl.enable(false);
    // this.menuCtrl.swipeEnable(false);

    events.subscribe('updatedhealthdeclare', () => {
      this.healthDeclareShow = false;
    });

    events.subscribe('reloadFutureEvents', () => {
      this.getFutureEvents();
      this.loadWeeklyRegistrations();
    });

    platform.resume.subscribe(() => {
      this.getTimeGreeting();
    });

    if (this.platform.is('android')) {
      this.platform.ready().then(() => {
        this.localNotifications.requestPermission().then((data => {
          console.log("localNotifications requestPermission", data);
        }));
      });
    }

  }

  ngOnInit() {
    console.log("oninit");
    this.loadWeeklyRegistrations();
  }

  loadWeeklyRegistrations() {
    if (this.weeklyRegChartLoading) {
      return;
    }

    const object = {
      personalID: localStorage.getItem('user_id'),
      mercazAllId: localStorage.getItem('mercazAllId'),
      pqpq: localStorage.getItem('server'),
    };

    this.weeklyRegChartLoading = true;
    this.api.sendPostParams('/graphs/getWeeklyRegs.php', object).then((response: any) => {
      this.weeklyRegChartLoading = false;
      console.log('getWeeklyRegs response:', response);
      if (response && response['sucsses']) {
        const rows = response.days || response.weeklyRegs || [];
        this.weeklyRegWeekTotal = Array.isArray(rows) ? rows.length : 0;
        this.buildWeeklyRegChart(this.parseWeeklyRegsByDay(response));
      } else {
        this.weeklyRegWeekTotal = 0;
        this.buildWeeklyRegChart(new Map());
      }
    }, (err) => {
      this.weeklyRegChartLoading = false;
      this.weeklyRegWeekTotal = 0;
      console.log('getWeeklyRegs error:', JSON.stringify(err));
      this.buildWeeklyRegChart(new Map());
    });
  }

  /** Map YYYY-MM-DD → count + hug names from getWeeklyRegs.php */
  private parseWeeklyRegsByDay(response: any): Map<string, { count: number; hugNames: string[]; label?: string }> {
    const byDay = new Map<string, { count: number; hugNames: string[]; label?: string }>();
    const rows = response.days || response.weeklyRegs || response.weeklyData || response.data || [];
    if (!Array.isArray(rows)) {
      return byDay;
    }

    rows.forEach((row: any) => {
      const iso = this.normalizeWeeklyDayIso(row.date || row.iso || row.dayDate || row.day);
      if (!iso) {
        return;
      }
      const count = Number(row.count != null ? row.count : (row.regCount != null ? row.regCount : (row.registrations != null ? row.registrations : row.total))) || 0;
      const hugNames = this.extractHugNamesFromDayRow(row);
      const label = row.label || row.dayLabel;
      byDay.set(iso, { count, hugNames, label });
    });
    return byDay;
  }

  private extractHugNamesFromDayRow(row: any): string[] {
    if (Array.isArray(row.hugNames)) {
      return row.hugNames.map((n: any) => String(n).trim()).filter(Boolean);
    }
    if (Array.isArray(row.names)) {
      return row.names.map((n: any) => String(n).trim()).filter(Boolean);
    }
    if (Array.isArray(row.hugim)) {
      return row.hugim
        .map((h: any) => (typeof h === 'string' ? h : (h.hugName || h.name || h.title || '')))
        .map((n: string) => String(n).trim())
        .filter(Boolean);
    }
    if (Array.isArray(row.hugs)) {
      return row.hugs
        .map((h: any) => (typeof h === 'string' ? h : (h.hugName || h.name || '')))
        .map((n: string) => String(n).trim())
        .filter(Boolean);
    }
    return [];
  }

  private normalizeWeeklyDayIso(raw: any): string {
    if (!raw) {
      return '';
    }
    const value = String(raw).trim();
    const m = moment(value, ['YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY', 'DD/MM/YY'], true);
    return m.isValid() ? m.format('YYYY-MM-DD') : '';
  }

  onWeeklyRegChartError(error: any) {
    console.log('weekly registrations chart error:', error);
  }

  onWeeklyChartSelect(event: ChartSelectEvent) {
    if (!event) {
      return;
    }

    let day = this.findWeeklyChartDayFromSelectEvent(event);
    if (!day) {
      return;
    }

    this.selectedChartDay = {
      label: day.label,
      count: day.count,
      hugNames: day.hugNames.slice(),
    };
  }

  /** Row index alone is wrong under RTL; use the label Google returns in the selection. */
  private findWeeklyChartDayFromSelectEvent(event: ChartSelectEvent) {
    const labelCandidates: string[] = [];
    if (event.selectedRowFormattedValues && event.selectedRowFormattedValues.length > 0) {
      labelCandidates.push(String(event.selectedRowFormattedValues[0]).trim());
    }
    if (event.selectedRowValues && event.selectedRowValues.length > 0) {
      labelCandidates.push(String(event.selectedRowValues[0]).trim());
    }

    for (const dayLabel of labelCandidates) {
      if (!dayLabel) {
        continue;
      }
      const byLabel = this.weeklyChartDays.find((d) => d.label === dayLabel);
      if (byLabel) {
        return byLabel;
      }
    }

    const row = event.row;
    if (row != null && row >= 1 && row - 1 < this.weeklyChartDays.length) {
      return this.weeklyChartDays[row - 1];
    }

    return null;
  }

  /** Sunday = start of week (Israel), same as getWeeklyRegs.php */
  private getWeekStartSunday(): moment.Moment {
    const today = moment().startOf('day');
    return today.clone().subtract(today.day(), 'days');
  }

  /** Week starts Sunday (Israel); data from getWeeklyRegs.php only. */
  buildWeeklyRegChart(
    apiByDay: Map<string, { count: number; hugNames: string[]; label?: string }>,
  ) {
    const weekStart = this.getWeekStartSunday();
    const today = moment().startOf('day');

    this.weeklyChartDays = [];
    const table: any[] = [['יום', 'הרשמות', { role: 'style' }]];
    let barColorIndex = 0;
    const cursor = weekStart.clone();

    while (cursor.isSameOrBefore(today, 'day')) {
      const iso = cursor.format('YYYY-MM-DD');
      const defaultLabel = this.hebrewWeekDays[cursor.day()] + ' ' + cursor.format('DD/MM');
      let count = 0;
      let hugNames: string[] = [];
      let label = defaultLabel;

      const fromApi = apiByDay.get(iso);
      if (fromApi) {
        count = fromApi.count;
        hugNames = fromApi.hugNames.slice();
        if (fromApi.label) {
          label = fromApi.label;
        }
      }

      if (count > 0) {
        const barColor = this.weeklyRegBarColors[barColorIndex % this.weeklyRegBarColors.length];
        this.weeklyChartDays.push({ iso, label, count, hugNames });
        table.push([label, count, `color: ${barColor}; stroke-color: #ffffff; stroke-width: 1`]);
        barColorIndex++;
      }
      cursor.add(1, 'day');
    }

    this.selectedChartDay = null;

    const chartHeight = Math.max(200, Math.round(this.platform.height() * 0.24));
    const chartWidth = Math.max(280, Math.round(this.platform.width()) - 48);

    this.weeklyRegChart = {
      chartType: 'ColumnChart',
      dataTable: table,
      options: {
        title: weekStart.format('DD/MM') + ' – ' + today.format('DD/MM/YYYY'),
        legend: { position: 'none' },
        height: chartHeight,
        width: chartWidth,
        fontSize: 13,
        backgroundColor: 'transparent',
        animation: { startup: true, duration: 700, easing: 'out' },
        bar: { groupWidth: '52%' },
        titleTextStyle: { color: '#1e293b', fontSize: 14, bold: true },
        hAxis: {
          title: 'יום',
          titleTextStyle: { color: '#64748b', fontSize: 12, bold: true },
          textStyle: { color: '#475569', fontSize: 11 },
          gridlines: { color: 'transparent' },
          baselineColor: '#cbd5e1',
        },
        vAxis: {
          minValue: 0,
          title: 'מספר הרשמות',
          format: '0',
          titleTextStyle: { color: '#64748b', fontSize: 12, bold: true },
          textStyle: { color: '#475569', fontSize: 11 },
          gridlines: { color: '#eef2ff', count: 4 },
          minorGridlines: { color: 'transparent' },
          baselineColor: '#e2e8f0',
        },
        chartArea: {
          width: '82%',
          height: '72%',
          backgroundColor: { fill: '#f8fafc', stroke: '#e0e7ff', strokeWidth: 1 },
        },
      },
    };
    this.showWeeklyRegChart = table.length > 1;
  }

  getNews() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
    };
    console.log("object:", object);
    this.newsLoading = true;
    this.api.sendPostParams('/news/getNews.php', object).then((response: any) => {

      console.log("response:", response);
      this.newsLoading = false;


      if (response['sucsses']) {
        if (response['mercazName']) {
          this.matnasName = response['mercazName'];
          localStorage.setItem('mercazName', response['mercazName']);
        }
        if (response['personalImage']) {
          localStorage.setItem('personalImage', response['personalImage']);
        }

        if (response['mercazDomain']) {
          localStorage.setItem('mercazDomain', response['mercazDomain']);
        }

        let eventData = {
          "personalImage": response['personalImage'],
          "personalFullName": localStorage.getItem('userName'),
        }

        this.events.publish('userDataEvent', eventData);

        this.newsItems = response['news'] || [];
        // this.barCode = response['barcode'];
        this.personalFound = response['personalFound'];
        // this.lastDigitsPersonalId = response['lastDigits'];
        this.healthDeclareShow = response['healthDeclareShow'];
        this.mustDeclareHealthGeneral = response['mustFillHealthDeclare'];
        this.checkGenerealHealthDeclare();

        // this.showRooEvents = response['showRooEvents'];

        this.mercazHugimVsActivity = response['mercazHugimVsActivity'];

        if (this.newsItems.length > 0) {
          this.showNews = true;
        } else {
          this.showNews = false;
        }

        this.activeTechNotifications = response['activeTechNotifications'] || [];

        if (this.activeTechNotifications.length > 0) {
          this.showActiveTecNotifications = true;
        } else {
          this.showActiveTecNotifications = false;
        }

      }

      this.loguserFunction();
    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.newsLoading = false;
      this.loguserFunction();
    }));
  }

  getFutureEvents() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
    };
    console.log("object:", object);
    this.futureEventsLoading = true;
    this.api.sendPostParams('/news/getFutureEvents.php', object).then((response: any) => {

      console.log("response:", response);

      if (response['sucsses']) {
        this.futureEvents = response['futureEvents'] || [];
      }
      if (this.futureEvents.length > 0) {
        this.showFutureEvents = true;
      } else {
        this.showFutureEvents = false;
      }
      this.futureEventsLoading = false;
      this.loadWeeklyRegistrations();
    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.futureEventsLoading = false;
      this.loadWeeklyRegistrations();
    }));
  }


  getQRCode() {
    this.qrImage = '';
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
    };
    console.log("object:", object);
    this.api.sendPostParams('/qr/generateQR.php', object).then((response: any) => {

      console.log("response:", response);
      this.qrImage = response['qrImage'];

    }, (err => {
      console.log("error2:", JSON.stringify(err));
    }));
  }




  openNews(row) {
    this.navCtrl.push('NewsPage', {
      "item": row
    });
  }

  getHugim() {
    this.stopTimers();
    if (this.personalFound) {
      if (this.mercazHugimVsActivity == 1) {
        let hugimSelectModal = this.modalCtrl.create('ActivityregmodalPage');
        hugimSelectModal.present();
      } else {
        this.navCtrl.push('HugimlistPage');
      }

    } else {
      let alertBox = this.alertCtrl.create({
        title: '<b>הינך חסום להרשמה לפעילויות אנא צור קשר או נסה להתחבר מחדש</b>',
        subTitle: '',
        buttons: [
          {
            text: 'ביטול',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'התחברות מחדש',
            handler: () => {
              localStorage.removeItem("mercazName");
              localStorage.removeItem("userName");
              localStorage.removeItem("user_id");
              localStorage.removeItem("mercazAllId");
              localStorage.removeItem("server");
              localStorage.removeItem("phone");
              this.navCtrl.setRoot('LoginPage');
            }
          }
        ]
      });
      alertBox.present();
    }
  }


  loguserFunction() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    // console.log("object:", object);

    this.api.sendPostParams('/log/logUser.php', object).then((data) => {
      this.getFutureEvents();
    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.getFutureEvents();
    }));
  }

  checkGenerealHealthDeclare() {
    if (this.mustDeclareHealthGeneral) {
      let alertBox = this.alertCtrl.create({
        title: '<b>יש תחילה למלא הצהרת בריאות בכדי להמשיך</b>',
        subTitle: '',
        enableBackdropDismiss: false,
        cssClass: 'hugRegisterClass',
        buttons: [

          {
            text: 'מעבר למילוי הצהרת בריאות',
            handler: () => {
              this.navCtrl.setRoot('HealthdeclaregeneralPage');
            }
          }
        ]
      });
      alertBox.present();
    }
  }

  getTimeGreeting() {
    const currentHour = Number(moment().format('HH'));
    if (currentHour >= 4 && currentHour < 10) {
      this.welcomeText = 'בוקר טוב';
    } else if (currentHour >= 10 && currentHour < 17) {
      this.welcomeText = 'צהריים טובים';
    } else if (currentHour >= 17 && currentHour < 21) {
      this.welcomeText = 'ערב טוב';
    } else if (currentHour >= 21 || currentHour < 4) {
      this.welcomeText = 'לילה טוב';

    }
  }

  onScroll(event) {
    // console.log(event);
    this.zone.run(() => {
      this.showScroller = event.scrollTop > 80 ? true : false;
    });
  };



  scrollTop() {
    setTimeout(() => {
      this.content.scrollToTop();
    }, 200);
  }

  goHealthDeclare() {
    this.navCtrl.push('HealthdeclarationPage');
  }

  goChatPage() {
    this.navCtrl.push('ChatPage');
  }

  openroom() {
    let roomSelectModal = this.modalCtrl.create('RoomsactivitymodalPage');
    roomSelectModal.present();
  }


  setReminder(row) {
    /** send local notification */
    // if (this.platform.is('android')) {

    // const meetingStartRemoveZeros = row.meetingStart.substring(0, 5);
    const dateString = row.logDate + ' ' + row.logTime;
    const notificationDate = new Date(dateString.replace(' ', 'T') + ':00');

    // Subtract two hours (2 hours = 2 * 60 * 60 * 1000 milliseconds)
    const twoHoursBefore = new Date(notificationDate.getTime() - (2 * 60 * 60 * 1000));

    const timestamp = new Date().getTime();


    try {
      this.localNotifications.schedule({
        id: timestamp,
        title: 'אקטיבטק - תזכורת לפעילות',
        text: 'זוהי תזכורת לפעילות ' + row.eventName + ' בעוד כשעתיים ' + row.logDate + ' ' + row.logTime,
        trigger: { at: twoHoursBefore },
        led: 'FF0000',
        // sound: null,
        icon: 'file://assets/imgs/icon.png',
      });
      this.showSwal("תזכורת נקבע בהצלחה", "נשלח לך התראה כשעתיים לפני מועד הפעילות", "success");
      row.notificationEnabled = false;
    } catch (error) {
      // console.error('Error scheduling notification', error);
      this.showSwal("שגיאה בקביעת תזכורת", "יש לאפשר הרשאות ולנסות שוב", "warning");
    }
    // }
  }


  setlocalNotificationRateUs() {

    try {
      const twoHoursFromNow = new Date(new Date().getTime() + 2 * 60 * 60 * 1000);
      this.localNotifications.schedule({
        id: 2,
        title: 'אקטיבטק - אנא דרגו אותנו בחנות',
        text: 'לחצ/י כאן כדי לדרג אותנו בחנות',
        trigger: { at: twoHoursFromNow },
        foreground: true,
        icon: 'file://assets/imgs/icon.png',
      });
    } catch (error) {
      // console.error('Error scheduling notification', error);
    }


    // Handle notification triggers

  }

  checkIfShowAd() {
    let dateNow = moment().format("YYYY-MM-DD");
    let lastShownAdNew = localStorage.getItem("lastShownAdNew");

    if (!lastShownAdNew) {
      localStorage.setItem("lastShownAdNew", dateNow);
      this.setlocalNotificationRateUs()
    }

    var today = moment().startOf('day')
    var createdDate = moment(lastShownAdNew, "YYYY-MM-DD").startOf('day')
    var diff = today.diff(createdDate, 'days')

    if (diff >= 60) {
      this.setlocalNotificationRateUs();
      localStorage.setItem("lastShownAdNew", dateNow);
    }
  }


  showSwal(title, text, type) {
    swal({
      icon: type,
      timer: 3000,
      title: title,
      text: text,
      buttons: ['']
    });
  }

  showQRCode() {
    this.resetTimers(); // prevent overlap if clicked again

    this.showQR = true;
    this.getQRCode();


    this.textTimer = setInterval(() => {
      this.getQRCode();
    }, 30000); // every 30 seconds

    this.hideTimer = setTimeout(() => {
      this.stopTimers();
    }, 180000); // after 3 minutes
  }

  resetTimers() {
    this.stopTimers();
  }

  stopTimers() {
    this.showQR = false;
    if (this.textTimer) {
      clearInterval(this.textTimer);
      this.textTimer = null;
    }

    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  ionViewWillLeave() {
    console.log("ionViewWillLeave");
    this.stopTimers(); // stop everything when leaving the page
  }

  ionViewDidLoad() {
    this.getNews();
    this.getTimeGreeting();

    if (this.platform.is('android')) {
      this.checkIfShowAd();
    }

    if (this.platform.is('android')) {
      this.isAndroid = true;
    }

    if (this.platform.is('cordova') && (this.platform.is('ios') || this.platform.is('android'))) {
      this.showRateStore = true;
      this.storeRateLabel = this.platform.is('ios') ? 'App Store' : 'Google Play';
    }

    if (this.RATE_MODAL_TEST_MODE) {
      this.showRateStore = true;
      if (!this.storeRateLabel) {
        this.storeRateLabel = 'App Store';
      }
    }

    this.showQuestionnaire = !isQuestionnaireSubmitted();

    this.maybeShowRateModal();
  }

  private maybeShowRateModal() {
    const isMobileBuild =
      this.platform.is('cordova') &&
      (this.platform.is('ios') || this.platform.is('android'));

    if (!this.RATE_MODAL_TEST_MODE && !isMobileBuild) {
      return;
    }

    if (!this.RATE_MODAL_TEST_MODE) {
      try {
        // Show only after the 2nd app launch (and only ever once).
        if (localStorage.getItem('rateModalShownV1') === '1') {
          return;
        }

        const raw = localStorage.getItem('rateModalAppLaunches');
        const launches = raw ? parseInt(raw, 10) : 0;
        if (isNaN(launches) || launches < 2) {
          return;
        }
      } catch (e) {
        return;
      }
    }

    setTimeout(() => {
      // this.openRateAppModal();
    }, this.RATE_MODAL_TEST_MODE ? 800 : 2500);
  }


  openMenuAction(action: { component: string, title?: string }) {
    if (!action) {
      return;
    }
    switch (action.component) {
      case 'registerActivity':
        this.getHugim();
        return;
      case 'showQr':
        this.showQRCode();
        return;
      case 'shareApp':
        this.openShareSheet();
        return;
      default:
        this.navCtrl.push(action.component);
    }
  }

  openQuestionnaire() {
    openQuestionnaireModal(this.modalCtrl).then((data: any) => {
      if (data && data.submitted) {
        this.showQuestionnaire = false;
      }
    });
  }

  openRateAppModal() {
    const modal = this.modalCtrl.create('RateappmodalPage', {}, {
      cssClass: 'rate-app-modal',
      enableBackdropDismiss: true,
    });
    modal.onDidDismiss((data: any) => {
      if (this.RATE_MODAL_TEST_MODE) {
        return;
      }
      if (data && (data.rated || data.later || data.closed)) {
        try { localStorage.setItem('rateModalShownV1', '1'); } catch (e) { /* noop */ }
      }
    });
    modal.present();
  }

  openShareSheet() {
    const shareText = "אפלקציית משתתפים בפעיליות במתחמי פעילות\n להורדה אנדרואיד: http://bit.ly/3lN9aQ6 \n להורדה אייפון: http://apple.co/3cfwfru";

    let actionSheet = this.actionSheetCtrl.create({
      title: 'שיתוף האפליקציה',
      cssClass: 'shareActionSheet',
      buttons: [
        {
          text: 'אימייל',
          icon: 'mail-outline',
          cssClass: 'shareActionSheet__btn-email',
          handler: () => {
            this.iab.create("mailto:?subject=אפליקציית אקטיבטק&body=" + shareText, '_system');
          }
        },
        {
          text: 'SMS',
          icon: 'text-outline',
          cssClass: 'shareActionSheet__btn-sms',
          handler: () => {
            this.iab.create("sms:?&body=" + shareText, '_system');
          }
        },
        {
          text: 'WhatsApp',
          icon: 'logo-whatsapp',
          cssClass: 'shareActionSheet__btn-whatsapp',
          handler: () => {
            this.iab.create("https://api.whatsapp.com/send?text=" + shareText, '_system');
          }
        },
        {
          text: 'ביטול',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

  onMatnasImgError(event: any) {
    this.matnasImage = '';
    try {
      if (event && event.target) {
        event.target.src = 'assets/imgs/icon.png';
      }
    } catch (e) { /* noop */ }
  }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts